import { ArrowLeftOutlined, ArrowUpOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Row,
  Select,
  Space,
  theme,
  InputNumber,
} from "antd";
import moment from "moment";
import React, { useState, useCallback, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SUCCESS_CODE, ERR_0022 } from "../../../lib/const";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useCountry from "../../../lib/hooks/useCountry";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../lib/hooks/useMasterData";
import useEState from "../../../lib/hooks/useEState";
import { DATA_MASTER_DATA_TYPE, ESTATE_TYPE } from "../../../lib/const";
import { routes } from "../../../routes";
import WithSidebar from "../../../templates/withSidebar";
import {
  updateAreaUsage,
  getListAreaUsageById,
} from "../../../services/customerAreaUsage";

import "./style.css";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";

const { useToken } = theme;
const { Option } = Select;

export const EditAreaUsage = () => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const [lineOfWork] = useLineOfWork();
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);
  const [estates, estateList] = useEState();
  const params = useParams();
  const navigate = useNavigate();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [countries] = useCountry();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState({});
  const [year, setYear] = useState(null);
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];

  const months = [
    {
      value: 10,
      name: "ตุลาคม",
    },
    {
      value: 11,
      name: "พฤศจิกายน",
    },
    {
      value: 12,
      name: "ธันวาคม",
    },
    {
      value: 1,
      name: "มกราคม",
    },
    {
      value: 2,
      name: "กุมภาพันธ์",
    },
    {
      value: 3,
      name: "มีนาคม",
    },
    {
      value: 4,
      name: "เมษายน",
    },
    {
      value: 5,
      name: "พฤษภาคม",
    },
    {
      value: 6,
      name: "มิถุนายน",
    },
    {
      value: 7,
      name: "กรกฎาคม",
    },
    {
      value: 8,
      name: "สิงหาคม",
    },
    {
      value: 9,
      name: "กันยายน",
    },
  ];

  const onFinish = async (values) => {
    const request = {
      yearOfBudget: values.yearOfBudget,
      month: values.month,
      lineOfWorkId: values.lineOfWorkId,
      estateId: values.estateId,
      areaUnderContract: values.areaUnderContract,
      declaredZone: values.declaredZone,
      masterPlanArea: values.masterPlanArea,
      areaForSaleOrRentGIZ: values.areaForSaleOrRentGIZ,
      areaForSaleOrRentIFZ: values.areaForSaleOrRentIFZ,
      areaForSaleOrRentCM: values.areaForSaleOrRentCM,
      availableAreaForSaleOrRentGIZ: values.availableAreaForSaleOrRentGIZ,
      availableAreaForSaleOrRentIFZ: values.availableAreaForSaleOrRentIFZ,
      availableAreaForSaleOrRentCM: values.availableAreaForSaleOrRentCM,
    };

    const res = await updateAreaUsage(params.id, request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.customer_tab_area_usage);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("ชุดการใช้พื้นที่ดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchAreaUsageById = useCallback(
    async (id) => {
      const res = await getListAreaUsageById(id);
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);
        // setDepartmentId(objectValue?.departmentId);

        form.setFieldsValue({
          yearOfBudget: objectValue?.yearOfBudget,
          month: objectValue?.month,
          lineOfWorkId: objectValue?.lineOfWorkId,
          lineOfWorkNameTh: objectValue?.lineOfWorkNameTh,
          lineOfWorkNameEn: objectValue?.lineOfWorkNameEn,
          estateId: objectValue?.estateId,
          estateNameTh: objectValue?.estateNameTh,
          estateNameEn: objectValue?.estateNameEn,
          areaUnderContract: objectValue?.areaUnderContract,
          declaredZone: objectValue?.declaredZone,
          masterPlanArea: objectValue?.masterPlanArea,
          areaForSaleOrRentGIZ: objectValue?.areaForSaleOrRentGIZ,
          areaForSaleOrRentIFZ: objectValue?.areaForSaleOrRentIFZ,
          areaForSaleOrRentCM: objectValue?.areaForSaleOrRentCM,
          availableAreaForSaleOrRentGIZ:
            objectValue?.availableAreaForSaleOrRentGIZ,
          availableAreaForSaleOrRentIFZ:
            objectValue?.availableAreaForSaleOrRentIFZ,
          availableAreaForSaleOrRentCM:
            objectValue?.availableAreaForSaleOrRentCM,
        });
      }
    },
    [setData]
  );

  useEffect(() => {
    fetchAreaUsageById(params.id);
  }, [params.id, fetchAreaUsageById]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_area_usage);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลการใช้พื้นที่",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_area_usage);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลการใช้พื้นที่"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="ปีงบประมาณ"
                        name={"yearOfBudget"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          maxTagCount={"responsive"}
                          onChange={() => {
                            let arr = form.getFieldValue().yearOfBudget;
                            setYear(arr);
                          }}
                          value={year}
                        >
                          {yearArray.map((item) => (
                            <Option value={parseInt(item) + 543}>
                              {parseInt(item) + 543}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="เดือนงบประมาณ"
                        name={"month"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          maxTagCount={"responsive"}
                          onChange={() => {
                            let arr = form.getFieldsValue().monthOfBudget;
                            const currentYear = new Date().getFullYear() + 543;
                            let arrYear = form.getFieldsValue().yearOfBudget;
                          }}
                        >
                          {months.map((m) => (
                            <Option value={m.value}>{m.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="สายปฏิบัติงาน"
                        name={"lineOfWorkId"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือกสายปฏิบัติงาน"
                        >
                          {lineOfWork.map((item) => (
                            <Option value={item.lineOfWork}>
                              {item.nameTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="นิคมอุตสาหกรรม"
                        name={"estateId"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <MultipleAutoComplete
                          multiple={false}
                          subject="estateName"
                          valueField="estateId"
                          labelField="estateNameTh"
                          placeholder="กรุณาเลือก"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่ขายตามสัญญา"
                        name={"areaUnderContract"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่ขายตามสัญญา"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่ประกาศเขต"
                        name={"declaredZone"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่ประกาศเขต"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่ตามผังแม่บท"
                        name={"masterPlanArea"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่ตามผังแม่บท"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่สำหรับขายหรือให้เช่า (GIZ)"
                        name={"areaForSaleOrRentGIZ"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่สำหรับขายหรือให้เช่า (GIZ)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่สำหรับขายหรือให้เช่า (IFZ)"
                        name={"areaForSaleOrRentIFZ"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่สำหรับขายหรือให้เช่า (IFZ)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่สำหรับขายหรือให้เช่า (CM)"
                        name={"areaForSaleOrRentCM"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่สำหรับขายหรือให้เช่า (CM)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (GIZ)"
                        name={"availableAreaForSaleOrRentGIZ"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (GIZ)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (IFZ)"
                        name={"availableAreaForSaleOrRentIFZ"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (IFZ)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (CM)"
                        name={"availableAreaForSaleOrRentCM"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          step="0.01"
                          placeholder="พื้นที่คงเหลือสำหรับขายหรือให้เช่า (CM)"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </WithSidebar>
  );
};
